import React from "react";
import { Button, MenuItem, Stack } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { LoadState } from "../../../../../../constants/enums";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import { StatusRenderer } from "../../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { PageContainer } from "../../../../../../components/container/PageContainer";
import { PageTitleBar } from "../../../../../../components/PageTitleBar/PageTitleBar";
import {
  clearCsioEdocsState,
  fetchCsioEdocsListAsync,
} from "../../../../../../redux/csioEdocs/csioEdocsActions";
import {
  ICSIOEDocs,
  initialCSIOEDocsState,
} from "../../../../../../redux/csioEdocs/csioEdocs.types";
import { CustomLink } from "../../../../../../components/CustomLink/CustomLink";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
} from "../../../../../../redux/messages/messagesActions";
import {
  downLoadFile,
  previewFile,
} from "../../../../../../features/FileUpload/utils";
import { EmailComposeRightPanel } from "../../../../../../components/MessagesDialogs/EmailCompose/EmailCompose";
import { useTableV2State } from "../../../../../../components/TableV2/hooks/useTableV2State";
import {
  TABLE_CACHING_KEYS,
} from "../../../../../../constants/constants";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { AddOutlined } from "@mui/icons-material";
import { DataTableV2 } from "../../../../../../components/TableV2/DataTableV2";
import {
  ControlledCustomSelect,
  CustomSelect,
} from "../../../../../../components/formsComponents";
import {
  initialNotice,
  INotices,
} from "../../../../../../redux/notices/notices.types";
import { ManageNotices } from "../../../../../notices/MangeNotices";
import { ManageEdocsRightPanel } from "../../../../../csioEdocs/ManageEdocsRightPanel";
import { CustomChip } from "../../../../../../components/CustomChip";

export const AutomobileCSIOEDocsList: React.FC = () => {
  const data1 = useOutletContext() as any;
  const customerId = data1[0];
  const customerpolicyId = data1[1];

  const { list, totalRecords, loading } = useSelector(
    (storeState: IStoreState) => storeState.csioEdocs
  );
  const [status, setStatus] = React.useState<"ACTIVE" | "DELETED" | "-1">("-1");
  const [type, setType] = React.useState<string>("-1");
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();
  const [openNotices, setOpenNotices] = React.useState<INotices | null>(null);
  const [openEdocs, setOpenEdocs] = React.useState<ICSIOEDocs | null>(null);
  const [actionState, setActionState] = React.useState<{
    action_needed: string;
    action_status: string;
  }>({ action_needed: "", action_status: "" });
  const {
    state: {
      dateState,
      tabs,
      columnsConfig,
      pagination,
      masterColumnResize,
      dense,
    },
    setDateState,

    setColumnVisibility,
    onPageChange,
    onRowsPerPageChange,
    onResizeMasterColumns,

    onDenseToggle,
  } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "allTimes",
      selectedTab: "-1",
    },
    pagination: {
      pageNumber: 1,
      rowsInPerPage: 25,
      apiFetchRowCount: 26,
      extraFetchFactor: 1,
    },

    cachingFilters: {
      uniqueKey: TABLE_CACHING_KEYS.AUTOMOBILE.CSIO_EDOCS,
    },
  });

  const fetchList = async () => {
    if (customerpolicyId) {
      dispatch(
        fetchCsioEdocsListAsync(
          pagination.pageNumber,
          pagination.rowsInPerPage,
          pagination.apiFetchRowCount,
          status,
          dateState.dates,
          [],
          customerpolicyId,
          type,
          undefined,
          actionState
        )
      );
    }
  };

  const handleComplete = () => {
    fetchList();
    setOpenNotices(null);
  };

  const handleEdocsComplete = () => {
    fetchList();
    setOpenEdocs(null);
  };

  React.useEffect(() => {
    fetchList();
    return () => {
      dispatch(clearCsioEdocsState());
    };
  }, [pagination, dateState.dates, status, type, actionState]);

  const handleRedirect = () => {
    setOpenEdocs({
      ...initialCSIOEDocsState.data,
      customer_id: customerId as any,
      customer_policy_id: customerpolicyId as any,
    });
  };

  const csioEdocsTableProps: IDataTableV2Props = {
    isPagination: true,
    rowsPerPageOptions: pagination.rowsInPerPage,
    extraFetchFactor: pagination.extraFetchFactor,
    isDataLoading: loading !== LoadState.Loaded,
    uniqueRowKeyName: "id",
    tableCommandBarProps: {
      preDefinedPlugins: {
        dateFilter: {
          state: dateState,
          onChange: setDateState,
        },
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {
        customPlugins: [
          // {
          //   key: "action_needed",
          //   onRender: () => (
          //     <ControlledCustomSelect
          //       name="action_needed"
          //       fullWidth
          //       value={actionState.action_needed}
          //       onChange={(e: any) =>
          //         setActionState({
          //           ...actionState,
          //           action_needed: e.target.value,
          //         })
          //       }
          //       variant="outlined"
          //       options={[
          //         { label: "All", value: "-1" },
          //         { label: "Invoice", value: "Invoice" },
          //         {
          //           label: "Invoice & Email Docs-Customer",
          //           value: "Invoice & Email Docs-Customer",
          //         },
          //         {
          //           label: "Invoice & Email Docs-Producer",
          //           value: "Invoice & Email Docs-Producer",
          //         },
          //         {
          //           label: "Invoice & Email Docs - Customer & Producer",
          //           value: "Invoice & Email Docs - Customer & Producer",
          //         },
          //       ]}
          //       displayEmpty
          //       placeholder="Action Needed"
          //     />
          //   ),
          // },
          // {
          //   key: "action_status",
          //   onRender: () => (
          //     <ControlledCustomSelect
          //       name="action_status"
          //       fullWidth
          //       value={actionState.action_status}
          //       onChange={(e: any) =>
          //         setActionState({
          //           ...actionState,
          //           action_status: e.target.value,
          //         })
          //       }
          //       variant="outlined"
          //       options={[
          //         { label: "All", value: "-1" },
          //         { label: "Pending", value: "PENDING" },
          //         {
          //           label: "Completed",
          //           value: "COMPLETED",
          //         },
          //       ]}
          //       displayEmpty
          //       placeholder="Action Status"
          //     />
          //   ),
          // },
          {
            key: "type",
            onRender: () => (
              <CustomSelect
                sx={{
                  minWidth: {
                    md: "80px",
                    lg: "",
                    xl: "120px",
                  },
                }}
                value={type}
                onChange={(e: any) => setType(e.target.value)}
              >
                <MenuItem value="-1">Both</MenuItem>
                <MenuItem value="EDOC">EDOC</MenuItem>
                <MenuItem value="NOTICE">NOTICE</MenuItem>
              </CustomSelect>
            ),
          },
          {
            key: "status",
            onRender: () => (
              <ControlledCustomSelect
                fullWidth
                value={status}
                name="status"
                onChange={(e) => setStatus(e.target.value as "ACTIVE")}
                placeholder="Select one"
                displayEmpty
                options={[
                  { label: "All", value: "-1" },
                  { label: "Open", value: "Open" },
                  { label: "Closed", value: "Closed" },
                ]}
              />
            ),
          },
        ],
      },
      rightItems: {
        customPlugins: [],
      },
    },

    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        disableResize: true,
        isFirstColumnSticky: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        headingAlign: "center",
        onRowCellRender: (value, row: ICSIOEDocs) => {
          const onlyPdf = row.attachment?.includes(".pdf");
          return (
            <StandardTableActions
              historyCompData={{ module_code: row.notice_and_edoc_code as any }}
              commentBoxTypeId={row.notice_and_edoc_code || undefined}
              onDownloadPreview={
                onlyPdf
                  ? async () => {
                    try {
                      dispatch(saveLoaderProgress());
                      await previewFile(row.attachment);
                    } catch (err) {
                      console.log(err);
                    } finally {
                      dispatch(saveLoaderCompleted());
                    }
                  }
                  : undefined
              }
              onDownLoadClick={
                onlyPdf
                  ? async () => {
                    try {
                      dispatch(saveLoaderProgress());
                      await downLoadFile(row.attachment);
                    } catch (err) {
                      console.log(err);
                    } finally {
                      dispatch(saveLoaderCompleted());
                    }
                  }
                  : undefined
              }
              onEditClick={() => {
                if (row.record_type === "EDOC") {
                  setOpenEdocs(row);
                } else {
                  setOpenNotices(row as INotices);
                }
              }}
              customComponentActions={row.customer_email ? [{
                component: (
                  <EmailComposeRightPanel
                    toEmail={row.customer_email}
                    attachements={[row.attachment as string]}
                    module={row.customer_policy_id ? {
                      module_name: "AUTOMOBILE POLICY",
                      module_code: row.customer_policy_id
                    } : undefined}
                    objectvaraibles={{
                      ...row,
                      policy_type: row.policy_type || "Automobile",
                    }}
                  />
                )
              }] : []}
            />
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        // exportCellWidth: 20,
        onRowCellRender: (value, row: ICSIOEDocs) => {
          return (
            <StatusRenderer
              status={row.status || ""}
            />
          );
        },
      },
      {
        key: "record_type",
        headerName: "Type",
        fieldName: "record_type",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 20,
        onRowCellRender: (value, row) => {
          const recordType = row.record_type;
          const colorType = recordType === "EDOC" ? "success" : "error";
          return (
            <CustomChip
              color={colorType}
              content={recordType}
              sx={{ color: "#000" }}
              size="small"
            />
          );
        },
      },

      {
        key: "notice_type",
        headerName: "Notice Type",
        fieldName: "notice_type",
        renderType: DataTableV2RowRenderType.CHIP_WARNING,
        onRowCellRender: (value, row) => {
          const type = row.notice_type || row.business_purpose_type;
          return `${type}`;
        },
      },
      {
        key: "create_ts",
        headerName: "Date Created",
        fieldName: "create_ts",
        renderType: DataTableV2RowRenderType.DATE_TIME,
        enableSorting: true,
      },
      {
        key: "insert_ts",
        headerName: "Date Modified",
        fieldName: "insert_ts",
        renderType: DataTableV2RowRenderType.DATE_TIME,
        enableSorting: true,
      },
      // {
      //   key: "csio_edoc_code",
      //   headerName: "Code",
      //   fieldName: "csio_edoc_code",
      //   renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
      //   // exportCellWidth: 15,
      //   enableSorting: true,
      //   // onRowCellRender: (value, row) => {
      //   //   const identifier = row.message_guid || row.csio_edoc_code;
      //   //   const displayValue = row.csio_edoc_code;
      //   //   return (
      //   //     <CustomLink
      //   //       to={"/csio-edocs-list/manage-csio-edoc/" + identifier}
      //   //       label={displayValue}
      //   //     />
      //   //   );
      //   // },
      // },
      {
        key: "customer_name",
        headerName: "Customer Name",
        fieldName: "customer_name",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 20,
      },
      {
        key: "policy_number",
        headerName: "Policy Number",
        fieldName: "policy_number",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 20,
        // onRowCellRender: (value, row) => {
        //   return (
        //     <Link
        //       sx={{ cursor: "pointer" }}
        //       onClick={handleEditRedirect(row.policy_number)}
        //     >
        //       {row.policy_number}
        //     </Link>
        //   );
        // },
      },

      {
        key: "type",
        headerName: "Message Type",
        fieldName: "type",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 20,
      },
      {
        key: "action_needed",
        headerName: "Action Needed",
        fieldName: "action_needed",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
      },
      {
        key: "action_status",
        headerName: "Action Status",
        fieldName: "action_status",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        onRowCellRender: (value, row) => {
          return <StatusRenderer status={row.action_status} />;
        },
      },
      // {
      //   key: "message_type",
      //   headerName: "Message Type",
      //   fieldName: "message_type",
      //   renderType: DataTableV2RowRenderType.TEXT_DARK,
      //   // exportCellWidth: 20,
      // },
      {
        key: "customer_email",
        headerName: "Email",
        fieldName: "customer_email",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 30,
        enableSorting: true,
        // onRowCellRender: (value, row: ICSIOEDocs) => {
        //   if (!row.customer_email) {
        //     return <>--</>;
        //   }
        //   return (
        //     <EmailComposeRightPanel
        //       displayLabel={row.customer_email}
        //       toEmail={row.customer_email}
        //       attachements={[row.attachment as string]}
        //     />
        //   );
        // },
      },
      // {
      //   key: "business_purpose_type",
      //   headerName: "Busines Purpose Type",
      //   fieldName: "business_purpose_type",
      //   renderType: DataTableV2RowRenderType.CHIP_WARNING,
      //   // exportCellWidth: 30,
      // },
      {
        key: "insurance_company",
        headerName: "Insurer",
        fieldName: "insurance_company",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 30,
      },
      {
        key: "line_of_business",
        headerName: "Line of Business",
        fieldName: "line_of_business",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 30,
      },
      // {
      //   key: "business_purpose_type",
      //   headerName: "Business Purpose Type",
      //   fieldName: "business_purpose_type",
      //   renderType: DataTableV2RowRenderType.TEXT,
      //   // exportCellWidth: 30,
      // },
      {
        key: "producer_code",
        headerName: "Producer Code",
        fieldName: "producer_code",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 30,
      },
      {
        key: "branch_code",
        headerName: "Branch Code",
        fieldName: "branch_code",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 30,
      },
      {
        key: "due_date",
        headerName: "Due Date",
        fieldName: "due_date",
        renderType: DataTableV2RowRenderType.DATE,
        // exportCellWidth: 30,
      },
      {
        key: "created_by_name",
        headerName: "Created By",
        fieldName: "created_by_name",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 30,
      },
      {
        key: "modified_by_name",
        headerName: "Modified By",
        fieldName: "modified_by_name",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 30,
      },


      {
        key: "notice_and_edoc_code",
        headerName: "Notice/Edoc Code",
        fieldName: "notice_and_edoc_code",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 20,
      },
      {
        key: "message_guid",
        headerName: "Message ID",
        fieldName: "message_guid",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        // exportCellWidth: 15,
        enableSorting: true,
        onRowCellRender: (value, row) => {
          const identifier = row.message_guid || row.csio_edoc_id;
          const displayValue = row.message_guid;
          return (
            <CustomLink
              to={"/csio-edocs-list/manage-csio-edoc/guid/" + identifier}
              label={displayValue}
            />
          );
        },
      },
    ],
    rows: list,
    onPageChange: onPageChange,
    onRowsPerPageChange: onRowsPerPageChange,
    // tableTabProps: {
    //   selectedTab: tabs.selectedTab,
    //   tabs: tabs.tabs,
    //   onTabChange: (newSelectedTab) => {
    //     setSelectedTab(newSelectedTab);
    //   },
    // },
    masterColumnResize: {
      values: masterColumnResize,
      onResize: onResizeMasterColumns,
    },
    dense: dense,
    onDenseToggle: onDenseToggle,
  };

  // React.useEffect(() => {
  //   const tabsData = createTabsWithRecordcounts(
  //     [
  //       { label: "Active", value: "ACTIVE", variant: "success" },
  //       { label: "Inactive", value: "INACTIVE", variant: "error" },
  //     ],
  //     recordsCounts
  //   );
  //   setTableTabs(tabsData);
  // }, [recordsCounts]);

  // React.useEffect(() => {
  //   dispatch(
  //     fetchRecordCountsAsync(
  //       "latest_csio_edoc",
  //       "status",
  //       dateState.dates.fromDate,
  //       dateState.dates.toDate,
  //       "csio"
  //     )
  //   );
  //   return () => {
  //     dispatch(clearRecordCounts());
  //   };
  // }, [dateState.dates.fromDate, dateState.dates.toDate]);

  return (
    <PageContainer title="View eDocs" description="this is innerpage">
      {/* <Breadcrumb title="" items={BCrumb} /> */}

      <PageTitleBar
        heading="eDocs/Notices"
        rightHeading={
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              onClick={handleRedirect}
              startIcon={<AddOutlined />}
            >
              Create Edoc
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setOpenNotices(initialNotice);
              }}
              startIcon={<AddOutlined />}
            >
              Create Notice
            </Button>
          </Stack>
        }
      />
      <DataTableV2 {...csioEdocsTableProps} />
      {openNotices && (
        <ManageNotices
          open={true}
          data={openNotices}
          onClose={() => setOpenNotices(null)}
          onComplete={handleComplete}
          customerId={customerId}
          customerpolicyId={customerpolicyId}
        />
      )}
      {openEdocs && (
        <ManageEdocsRightPanel
          open={true}
          data={openEdocs}
          onClose={() => setOpenEdocs(null)}
          onComplete={handleEdocsComplete}
          customerId={String(customerId)}
          customerPolicyId={customerpolicyId}
        />
      )}
    </PageContainer>
  );
};
